import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuodong",
  "use": "icon-tuodong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tuodong\"><defs><style type=\"text/css\"></style></defs><path d=\"M85.3 469.3h853.3v85.3H85.3zM768 341.3l-256-256-256 256M256 682.7l256 256 256-256\" p-id=\"2449\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol